import { styleOverrides } from "./styleOverrides";

const MuiDialogTitle = {
  styleOverrides,
};

export { MuiDialogTitle };
